import React, { useEffect, useState } from "react";
import PhotoUploadModal from "../../Models/ProfilephotoModel/EditprofilePhoto";
import EditcoverPhoto from "../../Models/CoverPhotoModel/EditcoverModel";
import EditSocialMediaModal from "../../Models/SocialMediaIconModel/SocialMediaIcon";
// import LazyLoad from 'react-lazy-load';

const ProfileBanner = ({ profiledata }) => {
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [showCoverModal, setShowCoverModal] = useState(false);
  const [showSocialModal, setShowSocialModal] = useState(false);
  const isValidImage = (url) =>
    url && url !== "null" && url !== undefined && url.trim() !== "";

  return (
    <>
      <PhotoUploadModal
        show={showPhotoModal}
        handleClose={() => setShowPhotoModal(false)}
      />

      <EditcoverPhoto
        show={showCoverModal}
        handleClose={() => setShowCoverModal(false)}
      />

      <EditSocialMediaModal
        show={showSocialModal}
        handleClose={() => setShowSocialModal(false)}
        company_data={profiledata.company_data}
      />

      <div className="card">
        <div className="cover-photo position-relative pb-5">
          <div className="position-relative" style={{ height: "350px" }}>
            {/* <LazyLoad> */}
            <img
              src={
                (isValidImage(profiledata?.company_data?.company_banner) && profiledata?.company_data?.company_banner.startsWith('http'))
                  ? profiledata.company_data.company_banner.replace(
                      "/thumb",
                      ""
                    )
                  : process.env.PUBLIC_URL + "/company-banner.jpg"
              }
              className="w-100 h-100"
              style={{ objectFit: "cover" }}
              alt="Company Banner"
            />

            {/* </LazyLoad> */}

            <button
              className="btn btn-light position-absolute  d-flex align-items-center justify-content-center shadow"
              style={{
                width: "40px",
                height: "40px",
                bottom: "2px",
                right: "1px",
                border: "1px solid #ddd",
              }}
              onClick={() => setShowCoverModal(true)}
            >
              <i className="bx bx-camera"></i>
            </button>
          </div>

          <div
            className="profile-pic position-absolute start-50 translate-middle-x"
            style={{ top: "70%" }}
          >
            <div className="position-relative">
            <img
                src={profiledata?.company_data?.company_logo}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    process.env.PUBLIC_URL + "/company-logo-design.jpg";
                }}
                className="rounded-circle"
                style={{
                  width: "150px",
                  maxWidth: "100%",
                  border: "5px solid rgb(79 75 75)",
                }}
                alt="Company Logo"
              />

              <button
                className="btn btn-light position-absolute rounded-circle d-flex align-items-center justify-content-center shadow"
                style={{
                  width: "40px",
                  height: "35px",
                  bottom: "0",
                  right: "0",
                  border: "1px solid #ddd",
                }}
                onClick={() => setShowPhotoModal(true)}
              >
                <i className="bx bx-camera"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column align-items-center text-center mt-5">
          <h3 className="fs-4 fw-bold">
            {profiledata?.company_data?.company_name}
          </h3>
          <p className="text-muted fs-6">
            <i class="fa-regular fa-building"></i>
            {profiledata?.company_data?.country}
          </p>

          <div className="d-flex justify-content-end align-items-center w-100 px-5 mb-2">
            <span className="text-muted fw-bold fs-6">Social Links</span>
            <button
              class="btn btn-outline-secondary bg-theme-color btn-sm ms-3"
              onClick={() => setShowSocialModal(true)}
            >
              <i class="bx bx-edit"></i>
            </button>
          </div>

          <div className="d-flex justify-content-end w-100 me-5 mb-2">
            <div className="border-1">
              <a
                href={profiledata?.company_data?.company_name}
                target="_blank"
                className="btn btn-primary btn-sm me-2"
              >
                <i className="bx bxl-facebook"></i>
              </a>
              <button class="btn btn-secondary btn-sm me-2">
              <i className="bx bxl-twitter"></i>
              </button>

              <a
                href="https://linkedin.com"
                target="_blank"
                className="btn btn-primary btn-sm me-2"
              >
                <i className="bx bxl-linkedin"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                className="btn btn-danger btn-sm"
              >
                <i className="bx bxl-instagram"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProfileBanner;
